import React from 'react';
import * as Linking from 'expo-linking';
import { OrganizationTypes } from '../../../../primary-record-types';
import Link from '../../../v2BaseComponents/Link';
import { useOrganizationClientRecordInvitationFile } from '../../../../hooks/api/useOrganizationClientRecordInvitationFile';
import { useOrganizationClientInvitationFile } from '../../../../hooks/api/useOrganizationClientInvitationFile';
import Stack from '../../../v2BaseComponents/Stack';

const FileContent: React.FC<{
    file: OrganizationTypes.InvitationDefinitionFile;
    onPress: () => void;
    isLoading: boolean;
}> = ({ file, onPress, isLoading }) => {
    return (
        <Link
            variant="body-1"
            onPress={onPress}
            testID={`consent-file-${file.name}`}
            linkColor={isLoading ? 'visited' : 'blue'}
            isDisabled={isLoading}
        >
            {file.description ? `${file.name} - ${file.description}` : file.name}
        </Link>
    );
};

const InvitationFile: React.FC<{
    file: OrganizationTypes.InvitationDefinitionFile;
    organizationClientInvitationId: string;
}> = ({ file, organizationClientInvitationId }) => {
    const { isLoadingClientInvitationFile, onLoadClientInvitationFile } = useOrganizationClientInvitationFile({
        onLoadClientInvitationFileSuccess: (response) => {
            Linking.openURL(response);
        },
    });

    return (
        <FileContent
            file={file}
            onPress={() => onLoadClientInvitationFile({ organizationClientInvitationId, fileId: file.fileId })}
            isLoading={isLoadingClientInvitationFile}
        />
    );
};

const ClientRecordFile: React.FC<{
    file: OrganizationTypes.InvitationDefinitionFile;
    organizationClientRecordId: string;
}> = ({ file, organizationClientRecordId }) => {
    const { isLoadingClientRecordInvitationFile, onLoadClientRecordInvitationFile } =
        useOrganizationClientRecordInvitationFile({
            onLoadClientRecordInvitationFileSuccess: (response) => {
                Linking.openURL(response.downloadUrl);
            },
        });

    return (
        <FileContent
            file={file}
            onPress={() => onLoadClientRecordInvitationFile({ organizationClientRecordId, fileId: file.fileId })}
            isLoading={isLoadingClientRecordInvitationFile}
        />
    );
};

export type InvitationFilesOwnProps = {
    files: OrganizationTypes.InvitationDefinitionFile[];
    organizationClientInvitationId?: string;
    organizationClientRecordId: string;
};

export type InvitationFilesProps = InvitationFilesOwnProps;

const InvitationFiles: React.FC<InvitationFilesProps> = (props) => {
    return (
        <Stack vertical fullWidth space={2} style={{ paddingLeft: 8 }}>
            {props.files.map((input, index) =>
                props.organizationClientInvitationId ? (
                    <InvitationFile
                        key={index}
                        file={input}
                        organizationClientInvitationId={props.organizationClientInvitationId}
                    />
                ) : (
                    <ClientRecordFile
                        key={index}
                        file={input}
                        organizationClientRecordId={props.organizationClientRecordId}
                    />
                ),
            )}
        </Stack>
    );
};

export default React.memo(InvitationFiles);
